//引入创建路由
import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";
//创建路由
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      // component: Home,
      component: () => import(/* webpackChunkName: "Home" */ '@/views/Home/index.vue'),
    },
    {
        path:"/Details",
        name:"Details",
        component: () => import(/* webpackChunkName: "Details" */ '@/views/Details/index.vue'),
    },
    {
      path:"/Product",
      name:"Product",
      component: () => import(/* webpackChunkName: "Product" */ '@/views/Product/index.vue'),
    },
    {
      path:"/control",
      name:"control",
      component: () => import(/* webpackChunkName: "control" */ '@/views/control/index.vue'),
    },
  
  ]
  
});


export default router
